import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/frontpage_header.jpg'
import _imports_1 from '@/assets/images/appstore_badge.svg'
import _imports_2 from '@/assets/images/playstore_badge.svg'


const _withScopeId = n => (_pushScopeId("data-v-ac306a58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid",
  style: {"padding":"0"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  id: "header-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "header-fader" }),
  /*#__PURE__*/_createElementVNode("img", {
    id: "header-image",
    src: _imports_0
  })
], -1))
const _hoisted_3 = {
  class: "row justify-content-center",
  id: "header-content"
}
const _hoisted_4 = {
  class: "col-12",
  id: "header-title"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_6 = { class: "col-8 col-md-3 col-xl-2" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkbadge",
  src: _imports_1
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "col-8 col-md-3 col-xl-2" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkbadge",
  src: _imports_2
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_15 = {
  class: "col-11 col-md-8 col-xl-5",
  id: "header-text"
}
const _hoisted_16 = {
  key: 0,
  class: "feed-header"
}
const _hoisted_17 = {
  key: 1,
  class: "row justify-content-center feed"
}
const _hoisted_18 = { class: "col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feed_component = _resolveComponent("feed-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('home-header')), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: _ctx.appstoreLink(),
          target: "_blank",
          class: "linkbadgeWrapper",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadBadgeClick && _ctx.downloadBadgeClick(...args)))
        }, _hoisted_9, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          href: _ctx.googlePlayLink(),
          target: "_blank",
          class: "linkbadgeWrapper",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadBadgeClick && _ctx.downloadBadgeClick(...args)))
        }, _hoisted_13, 8, _hoisted_11)
      ]),
      _hoisted_14,
      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t('home-subheader')), 1)
    ]),
    (_ctx.newFeed.items && _ctx.newFeed.items.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Top-Uploads"))
      : _createCommentVNode("", true),
    (_ctx.newFeed.items && _ctx.newFeed.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_feed_component, {
              items: _ctx.newFeed.items
            }, null, 8, ["items"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}